var map = {
	"./check-card.png": 3636,
	"./check-quiz.png": 63,
	"./check.png": 551,
	"./checkJoinedMatch.png": 6822,
	"./checkfalse.png": 9380,
	"./checktrue.png": 4966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8572;